// extracted by mini-css-extract-plugin
export default {"button":"patchStyle_button__rGaPt","card":"patchStyle_card__NeVeR","font":"patchStyle_font__hP8BY","custom-scrollbar":"patchStyle_custom-scrollbar__hDQra"};